var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 18.3333C3.33301 14.6514 6.31777 11.6667 9.99967 11.6667C13.6816 11.6667 16.6663 14.6514 16.6663 18.3333H14.9997C14.9997 15.5719 12.7611 13.3333 9.99967 13.3333C7.23825 13.3333 4.99967 15.5719 4.99967 18.3333H3.33301ZM9.99967 10.8333C7.23717 10.8333 4.99967 8.59584 4.99967 5.83334C4.99967 3.07084 7.23717 0.833336 9.99967 0.833336C12.7622 0.833336 14.9997 3.07084 14.9997 5.83334C14.9997 8.59584 12.7622 10.8333 9.99967 10.8333ZM9.99967 9.16667C11.8413 9.16667 13.333 7.675 13.333 5.83334C13.333 3.99167 11.8413 2.5 9.99967 2.5C8.15801 2.5 6.66634 3.99167 6.66634 5.83334C6.66634 7.675 8.15801 9.16667 9.99967 9.16667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOrderIcon);
export default __webpack_public_path__ + "static/media/profileOrderIcon.1beb51305ac4766a8d539bd63dc3d482.svg";
export { ForwardRef as ReactComponent };